<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        small
        @click="doClipboard()"
        v-on="on"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { getClipboard } from "../helpers/getClipboard.js";
export default {
  props: ["text", "tooltipText"],
  data() {
    return {
      copied: false,
    };
  },
  computed: {
    tooltip() {
      return this.copied ? "Готово" : this.tooltipText;
    },
  },
  methods: {
    doClipboard() {
      getClipboard(this.text);
      this.copied = true;
    },
  },
};
</script>
